import { TicketStatusEnum } from '@/generated/openapi';
import _trim from 'lodash.trim';
import { RouteLocationNormalizedLoaded, RouteLocationRaw, Router } from "vue-router";

const PARAM_BACK = 'fromSearch'

function urlParamString(route: RouteLocationNormalizedLoaded, paramName: string): string {
  const param = route.params[paramName]
  if (typeof param === 'string') {
    return param;
  }
  return param.join('')
}

function urlQueryString(route: RouteLocationNormalizedLoaded, queryName: string): string {
  const query = route.query[queryName]
  if (typeof query === 'string') {
    return query;
  }
  return ''
}

function urlQueryTicketStatusEnum(route: RouteLocationNormalizedLoaded, queryName: string): TicketStatusEnum {
  const query = route.query[queryName]
  if (query === TicketStatusEnum.Cancelled) {
    return TicketStatusEnum.Cancelled
  } else if (query === TicketStatusEnum.New) {
    return TicketStatusEnum.New
  }
  return TicketStatusEnum.Booked
}


function urlQueryStringArr(route: RouteLocationNormalizedLoaded, queryName: string): string[] {
  const query = route.query[queryName]
  if (Array.isArray(query)) {
    return query as string[]
  }
  return []
}

function urlQueryInt(route: RouteLocationNormalizedLoaded, queryName: string): number {
  const query = route.query[queryName]
  const asNumber = Number.parseInt(query as any)
  if (Number.isFinite(asNumber)) {
    return asNumber
  }
  return 0
}

function buildUrl(baseUrl: string, ...pathParts: string[]) {
  const path = [baseUrl, ...pathParts].map(path => _trim(path, '/')).join('/')
  return baseUrl.startsWith('/') ? ('/' + path) : path
}

function smartBack($router: Router, fallbackRoute: RouteLocationRaw|string) {
  const $route: RouteLocationNormalizedLoaded = $router.currentRoute.value
  if ($route.query[PARAM_BACK] === 'y') {
    $router.back()
  } else {
    $router.push(fallbackRoute)
  }
}

export {
  urlParamString,
  urlQueryString,
  urlQueryTicketStatusEnum,
  urlQueryStringArr,
  urlQueryInt,
  buildUrl,
  smartBack
};

